const decode = (data) => {
  return decodeURIComponent(escape(atob(reverse(data.slice(0, -7)))))
}
const decodeToken = (data) => {
  return escape(atob(reverse(data.slice(0, -10)))).slice(0, -5)
}

const decodeAuthen_news = (data) => {
  return decodeURIComponent(escape(atob(reverse(data.slice(7).slice(0, -10)))))
  // randomString(7) + reverse(btoa(unescape(encodeURIComponent(JSON.stringify(data))))) + randomString(10)
}

function reverse (s) {
  return s.split('').reverse().join('')
}
export default {
  decode,
  decodeToken,
  decodeAuthen_news
}
